import { RenderUnsettledUI } from 'shared/components';
import {
  useGetFilterBusinessUnitsData,
  useGetFilterJobTypesData,
  useGetFilterWorkersData,
} from 'partner/hooks/use-get-filters-data';
import { PlacementsFiltersDataProviderProps } from './placements-filters.types';
import { PlacementsFilters } from './placements-filters';

export const PlacementsFiltersDataProvider = ({
  onClose,
  handleFiltersChange,
  appliedFilters,
}: PlacementsFiltersDataProviderProps) => {
  const businessUnitsQuery = useGetFilterBusinessUnitsData({
    jobTypeIds: appliedFilters.jobType,
  });

  const jobTypeQuery = useGetFilterJobTypesData({
    companyId: appliedFilters.company,
    branchOfficeIds: appliedFilters.branchOfficeIds,
    departmentIds: appliedFilters.departmentIds,
  });

  const workersQuery = useGetFilterWorkersData();

  if (businessUnitsQuery.status !== 'success') {
    return <RenderUnsettledUI data={businessUnitsQuery} />;
  }

  if (jobTypeQuery.status !== 'success') {
    return <RenderUnsettledUI data={jobTypeQuery} />;
  }

  if (workersQuery.status !== 'success') {
    return <RenderUnsettledUI data={workersQuery} />;
  }

  return (
    <PlacementsFilters
      onClose={onClose}
      appliedFilters={appliedFilters}
      handleFiltersChange={handleFiltersChange}
      filterData={{
        companies: businessUnitsQuery.data.companies,
        jobTypes: jobTypeQuery.data.jobTypes,
        workers: workersQuery.data,
      }}
    />
  );
};
